import { render } from "./InnovationCard.vue?vue&type=template&id=ab0e97fa&scoped=true"
import script from "./InnovationCard.vue?vue&type=script&lang=js"
export * from "./InnovationCard.vue?vue&type=script&lang=js"

import "./InnovationCard.vue?vue&type=style&index=0&id=ab0e97fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab0e97fa"]])

export default __exports__